import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-vertical-connection',
  templateUrl: './vertical-connection.component.html',
  styleUrls: ['./vertical-connection.component.scss']
})
export class VerticalConnectionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
